module.exports = __webpack_public_path__ + "img/banner-decent-work-and-economy-growth.9b8316aa.png";